import { apiClient } from '../../lib/api-client';
import type { AuditLogFilters, AuditLogResponse } from './types';

const compactParams = (params: object) => Object.fromEntries(
  Object.entries(params).filter(([, value]) => value !== '' && value !== undefined && value !== null),
);

export const fetchAuditLogs = async (filters: AuditLogFilters) => {
  const response = await apiClient.get<AuditLogResponse>('/audit-logs', { params: compactParams(filters) });
  return response.data;
};
